import * as styles from './FilterDivider.module.css'

function FilterDivider() {
  return (
    <div className={styles.filterDivider}>
      <span className={styles.dividerElement}></span>
    </div>
  )
}

export default FilterDivider
